import { render, staticRenderFns } from "./vip-module.vue?vue&type=template&id=6f66f5af&scoped=true&"
import script from "./vip-module.vue?vue&type=script&lang=js&"
export * from "./vip-module.vue?vue&type=script&lang=js&"
import style0 from "./vip-module.vue?vue&type=style&index=0&id=6f66f5af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f66f5af",
  null
  
)

export default component.exports